import { Directive, Input, OnChanges, inject, input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { keys } from 'lodash-es';
import { DEFAULT_ERROR_MESSAGES, FORM_ERROR_PROVIDER } from '../form-error/form-error.constants';
import { FormErrorsMap } from '../form-error/form-error.model';

export const ErrorsFormControlDirectiveInputs = ['customErrorLabels', 'errors'];

@Directive({
  selector: '[uiErrorsFormControl]',
  standalone: true,
})
export class ErrorsFormControlDirective implements OnChanges {
  private _globalConfig = inject<FormErrorsMap>(FORM_ERROR_PROVIDER, { optional: true });

  readonly customErrorLabels = input<ValidationErrors>({});

  @Input()
  errors: ValidationErrors | null = null;

  mergedConfig: FormErrorsMap = {};
  currentError: string | null = null;

  ngOnChanges() {
    this.mergedConfig = {
      ...DEFAULT_ERROR_MESSAGES,
      ...(this._globalConfig ?? {}),
      ...this.customErrorLabels(),
    };

    const [firstKey] = keys(this.errors);
    const getError = this.mergedConfig[firstKey];

    if (!getError) {
      this.currentError = null;
      return;
    }

    this.currentError = (
      typeof getError === 'function' && this.errors ? getError(this.errors[firstKey]) : getError
    ) as string;
  }
}
